import React, { useState, useCallback, useRef, useEffect, ChangeEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import ModalSheet from '../../basic/ModalSheet';
import { formatDateTime } from '../../../helpers/dates';
import { Stack, Textarea, FormControl, Text } from '@primer/react'
import { AdsResponse } from '../../../types/api/ads';
import { CommentResponse } from '../../../types/api/comments';
import { fetchModeratorComments } from '../../../services/moderatorComments';

interface DisplayAdsCommentModalProps {
    ads: AdsResponse
    comment: string
    isOpen: boolean;
    onClose: () => void;
}

export const DisplayAdsCommentModal: React.FC<DisplayAdsCommentModalProps> = ({ ads, isOpen, comment, onClose }) => {

    const [comments, setComments] = useState<CommentResponse[] | undefined>(undefined);

    const adInfoText = `Наименование —  ${ads.title}
                        Имя —  ${ads.user?.username}
                        Дата —  ${formatDateTime(ads.createdAt)}
                        `

    useEffect(() => {
        fetchModeratorCommentsForAd({
            entity_id: ads.id,
            entity_type: 'ad',
            is_admin: true
        });
    }, []);

    const { mutate: fetchModeratorCommentsForAd, isPending: isLoadingComment } = useMutation({
        mutationFn: fetchModeratorComments,
        onSuccess: (data) => {
            setComments(data.list)
        },
        onError: (error: any) => {
            console.error('error fetchModeratorComments', error);
        }
    });

    return (
        <ModalSheet
            isOpen={isOpen}
            onClose={onClose}
            title="Комментарий к удаленному объявлению"
            size="middle"
            headerSize="regular"
        >
            {({ setTitle }) => (
                <Stack className='mt-[16px]'>
                    <Text
                        className='whitespace-pre-line'
                        fontSize={12}
                        fontWeight="medium"
                        color="fg.muted"
                        lineHeight="medium">
                        {adInfoText}
                    </Text>
                    {comments?.map((e: CommentResponse, index) => (
                        <div
                            key={e.id}
                            className="
                            bg-header
                            border border-border
                            rounded-lg 
                            px-3 py-3
                            w-full
                        ">
                            <Text
                                fontSize={14}
                                fontWeight="medium"
                                color="fg.muted"
                                className="break-words"
                                lineHeight="medium">
                                {e.content}
                            </Text>
                        </div>
                    ))}
                </Stack>
            )}
        </ModalSheet>
    );
};